import useAddress from '@/containers/SubscriptionFormPageNew/Components/Address/useAddress'
import SDFormControl from '@/shared/components/SDComponentsNewDesign/SDFormControl/SDFormControl'
import getError from '@/containers/SubscriptionFormPageNew/getError'
import SDInput from '@/shared/components/SDComponentsNewDesign/SDInput/SDInput'

const City = () => {
  const { t, errors, city, showAddressFields, customInput, updateAddress, isEditable } = useAddress()

  if (!showAddressFields) {
    return null
  }

  return (
    <SDFormControl plainLabel error={getError('city', errors)}>
      <SDInput
        label={t('subscriptionForm:address_module.readonly_city')}
        currentValue={city}
        readOnly={!customInput}
        disabled={!customInput || isEditable === false}
        onBlur={customInput ? value => updateAddress({ city: value }) : undefined}
        overrides={undefined}
        status={undefined}
        outerOnchange={undefined}
      />
    </SDFormControl>
  )
}

export default City
